import React from "react";
import { ErrorBoundary } from "@appsignal/react";
import { appsignal } from "../../services/appsignalService";
import ErrorPage from "./ErrorPage.jsx";

export default function AppSignalWrapper({ children }) {
  return (
    <ErrorBoundary
      instance={appsignal}
      // tags={{ tag: "test" }} // optional
      fallback={(error) => <ErrorPage error={error} />} // optional
    >
      {children}
    </ErrorBoundary>
  );
}
